import { ReactComponent as Profile } from '../../assets/icons/profile.svg';
import StaffScheme from '../../features/staff/staffEnum';
import { useAppSelector } from '../../app/hooks';


const Personnel = (props: StaffScheme & { onClick: () => void }) => {

  return (
    <div className="staff user" onClick={props.onClick}>
      <div className="user__icon">
        <Profile />
      </div>
      <div>
        <h2 className="user__name">{props.name}</h2>
        <div className="label--gray">{props.email}</div>
      </div>
    </div>
  )
}

export default Personnel;